export default {
  setCookie: function (cname, cvalue, date, domain) {
    let cookieString = encodeURIComponent(cname) + '=' + encodeURIComponent(cvalue) + ';path=/'
    if (date) cookieString += ';expires=' + date
    if (domain) cookieString += ';domain=' + domain
    document.cookie = cookieString
  },
  getCookie: function (cname) {
    let name = encodeURIComponent(cname) + '='
    let cookie = document.cookie
    let ca = cookie.split(';')
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i]
      while (c.charAt(0) === ' ') {
        c = c.substring(1)
      }
      if (c.indexOf(name) === 0) {
        return decodeURIComponent(c.substring(name.length, c.length))
      }
    }
    return ''
  }
}



// WEBPACK FOOTER //
// ./src/services/cookie.js